export enum EmployeeDetailsView {
  Shifts,
  Sales,
  Data,
  Anmeldung,
  Submissions
}
